// Generated by ReScript, PLEASE EDIT WITH CARE


var desktopLogoWidth = 91.8;

var desktopLogoHeight = 18.0;

var mobileLogoWidth = 76.5;

var mobileLogoHeight = 15.0;

var orderHistoryPath = "/order-history";

export {
  desktopLogoWidth ,
  desktopLogoHeight ,
  mobileLogoWidth ,
  mobileLogoHeight ,
  orderHistoryPath ,
}
/* No side effect */
